import styled from 'styled-components';
import { ListItemText, withStyles } from '@material-ui/core';

export const FooterItem = styled.div`
  font-family: 'NSCJKrL';
  font-size: 16px;
  line-height: 25px;
`;

export const FooterLink = styled.div`
  font-family: 'NSCJKrL';
  font-size: 16px;
  line-height: 25px;
  color: black;
  cursor: pointer;
`;

export const PCFooter = styled.div`
  height: 300px;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const MobileFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const GnbFooterListText = withStyles({
  primary: {
    fontFamily: 'NSCJKrL',
    fontSize: 16,
    color: 'black',
  },
})(ListItemText);
